import { Fetch, AppConfig } from '../helpers'

export default class membersApi {

    static AddMemberPhone = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'AddMemberPhone',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }


    static UpdateMemberDetails = (data) => {

        const response = Fetch.fetch(
            {
                methodName: 'UpdateMemberDetails',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static GetMemberDetails = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'GetMemberDetails',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static SendVerifyEmail = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'SendVerifyEmail',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static ValidateVoucherDeposit = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'ValidateVoucherDeposit',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static mtnDeposit = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'MtnMobileMoneyDeposit',
                url: AppConfig.api.members,
                data
                
            }
        )
        return response;
    }
    static orangeDeposit = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'OrangeDeposit',
                url: AppConfig.api.members,
                data
                
            }
        )
        return response;
    }

    static mtnWithdraw = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'MtnMobileMoneyWithdrawal',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static tipmeWithdraw = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'TipMeEstimateChargesWithdrawal',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static tipmeConfirmWithdraw = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'TipMeWithdrawal',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static orangeWithdraw = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'OrangeWithdrawal',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
 

    static DepositFromVoucher = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'DepositFromVoucher',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static ValidateWithdrawal = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'ValidateWithdrawal',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static WithdrawalToVoucher = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'WithdrawalToVoucher',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static MemberTransactions = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'MemberTransactions',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static MemberForms = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'MemberForms',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static FormsDetails = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'FormsDetails',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static tipMeSearchCustomer = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'TipMeSearchCustomer',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static DepositeTipMe = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'TipMeVerifyPinEstimateDeposit',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static firstDepositeFirstStepMessage = (data) => {
        
        const response =fetch(AppConfig.api.pageMessages + data, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json; charset=UTF-8'
            }
        }).then(response => response.json())
        return response;
    }

    static addProviderList = () => {
        const response = Fetch.fetch(
            {
                methodName: 'GetProviders',
                url: AppConfig.api.members,
            }
        )
        return response;
    }

    static tipMeOTPVertificaton = (data , methodName) => {
        const response = Fetch.fetch(
            {
                methodName: `${methodName}`,
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static AddMemberProviders = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'AddMemberProviders',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static getRewards = () => {
        const response = Fetch.fetch(
            {
                methodName: 'CustomerClubMemberReward',
                url: AppConfig.api.members,
            }
        )
        return response;
    }
    static getRewardsTransaction = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'CustomerClubRewardTransactions',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static clubRewardStatus = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'CustomerClubRewardSystem',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }


    static clubMemberRewardInfo = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'CustomerClubMemberRewardInfo',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static customerClubRewardRedeem = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'CustomerClubRewardRedeem',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static getWheelOfFortuneGift = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'GetWheelOfFortuneGift',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static wheelOfFortuneSpin = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'WheelOfFortuneSpin',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static MemberProvidersList = () => {
        const response = Fetch.fetch(
            {
                methodName: 'GetMemberProviders',
                url: AppConfig.api.members,
            }
        )
        return response;
    }

    static GetVoucherDetails = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'VoucherDetails',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static placeBetStaticLive = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'PlaceBetStaticLive',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static PlaceBetCustomBet = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'PlaceBetCustomBet',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static placeBetVirtual = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'PlaceBetVirtual',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static placeBetSingles = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'PlaceBetSingles',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static memberApprovedJackpotWinnings = (data) => {
        const response = Fetch.fetch(
            {
                methodName: "MemberApprovedJackpotWinnings",
                method: "POST",
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static checkDepositBonusConditions = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'CheckDepositBonusConditions ',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static createCustomerServiceCode = (data) => {
        const response = Fetch.fetch(
            {
                methodName: 'CreateCustomerServiceCode ',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static getSignedInLoyalityRewards = () => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'GetLoyaltyRewardsOptions',
                url: AppConfig.api.members,
            }
        )
        return response;
    }
    static GetLoyaltyRewardsCoupons = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'GetLoyaltyRewardsCoupons',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static CreateMemberSlotsBonus = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'CreateMemberSlotsBonus',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static GetLastRewardNotifications = () => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'GetLastRewardNotifications',
                url: AppConfig.api.members,
            }
        )
        return response;
    }
    static GetNotificationHistory = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'GetNotificationHistory',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static DeleteNotification = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'DeleteNotification',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static GetNotificationCount = () => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'GetNotificationCount',
                url: AppConfig.api.members,
            }
        )
        return response;
    }
    static MuteNotification = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'MuteNotification',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static getFormCashOutOffer = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'GetFormCashOutOffer',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static earlyCashOut = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'EarlyCashOut',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static NotificationDetails = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'NotificationDetails',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }

    static ReadNotificationStatus = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'ReadNotificationStatus',
                url: AppConfig.api.general,
                data
            }
        )
        return response;
    }
    static ManageMemeberFavorite = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'ManageMemeberFavorite',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static CreateMemberSlotsBonusByCouponCode = (data) => {
        const response = Fetch.fetch(
            {
                method:"POST",
                methodName: 'CreateMemberSlotsBonusByCouponCode',
                url: AppConfig.api.members,
                data
            }
        )
        return response;
    }
    static validateCoupon = (data) => {
		const response = Fetch.fetch(
			{
				method: 'POST',
				methodName: 'ValidateCoupon',
				url: AppConfig.api.members,
				data
			}
		)
		return response;
	}
    static CouponConfirmByCouponCode = (data) => {
		const response = Fetch.fetch(
			{
				method: 'POST',
				methodName: 'CouponConfirmByCouponCode',
				url: AppConfig.api.members,
				data
			}
		)
		return response;
	}

}
